import React, { useState } from "react";
import styles from "./style.scss";
import { Col, Row } from "antd";
import SearchControl from "../../../../../../../../components/SearchControls/SearchGroups/SearchControl";
import FilterGroupAccordion, {
  hasActiveValue,
  mergeUnnamedIntoFirst
} from "../../../../../../../../components/SearchControls/SearchGroups/FilterGroupAccordion";
import SearchGroup from "../SearchGroup";
import { ControlType } from "../../../../../../../../models";

const AllSearchControls = props => {
  const { groupConfigs: rawGroupConfigs, form, onSubmit, onReset, isMobile, showAllControls, setShowAllControls } = props;
  const groupConfigs = mergeUnnamedIntoFirst(rawGroupConfigs);
  const [explicitOpen, setExplicitOpen] = useState({});

  const getIsOpen = (index, controls) => {
    if (explicitOpen[index] !== undefined) return explicitOpen[index];
    if (hasActiveValue(controls)) return true;
    if (index === 0) return true;
    return false;
  };
  const toggleGroup = (index, controls) => {
    setExplicitOpen({ ...explicitOpen, [index]: !getIsOpen(index, controls) });
  };

  return (
    <div style={{ width: "100%", display: showAllControls ? "block" : "none" }}>
      {groupConfigs.map((groupConfig, index) => {
        const isOpen = getIsOpen(index, groupConfig.controls);
        // Index 0 reuses SearchGroup so the primary-fields layout (with
        // category-specific column widths) matches the closed-panel quick
        // search bar one-to-one.
        const body = index === 0 ? (
          <SearchGroup
            form={form}
            groupConfig={groupConfig}
            onSubmit={onSubmit}
            onReset={onReset}
            isMobile={isMobile}
            showAllControls={false}
            setShowAllControls={setShowAllControls}
            hideSearchButton={true}
          />
        ) : (
          <Row type="flex" gutter={12}>
            {groupConfig.controls.map((controlConfig, i) => (
              <Col
                span={controlConfig.fromField === "fuelConsumptionCombFrom" ? 16 : 4}
                key={i}
                className={`${controlConfig.field}Search`}
                style={{
                  maxHeight: controlConfig.type == ControlType.multiLevel ? "55px" : undefined
                }}
              >
                <SearchControl
                  key={i}
                  form={form}
                  controlConfig={controlConfig}
                  isMobile={isMobile}
                  onSubmit={onSubmit}
                  showPlaceholder={true}
                  showAllControls={showAllControls}
                  isSearch={true}
                  isColumn={false}
                />
              </Col>
            ))}
          </Row>
        );
        return (
          <div key={index} className={styles.rowWrapper}>
            <FilterGroupAccordion
              name={groupConfig.name || "Osnovni podaci"}
              isOpen={isOpen}
              onToggle={() => toggleGroup(index, groupConfig.controls)}
              titleClassName={styles.title}
            >
              {body}
            </FilterGroupAccordion>
          </div>
        );
      })}
    </div>
  );
};

export default AllSearchControls;



// WEBPACK FOOTER //
// ./src/containers/ModulePage/SubLevel1/SubLevel1Desktop/FilterSection/SearchControls/SearchGroups/AllSearchControls/index.tsx